import {useState } from 'react';
import styled from 'styled-components';
import Button from './Button';
import MessageBox from './MessageBox';
import QuizStepDisplay from './QuizStepDisplay';
import './../style.css'
import './../css/bootstrap.css'
import './../css/dark.css'
import './../css/font-icons.css'
import './../css/components/ion.rangeslider.css'
import './../css/custom.css'
import './../css/fonts.css'



const Styles = styled.div`
ul{
    list-style-type:none;
    display: flex;
}
li{
    display: flex;
    padding: 0;
}
.input-field{
    display: flex;
    flex-direction: column;
    margin: 10px 0;
}
.input-field.error>label{
    color: var(--color-primary-opposite);
}

.errors{
    display: flex;
    flex-direction: row;
}
.footer>*{
    margin-bottom: 10px;
    position: right;
}
.msgBox{
    margin: 0 5px 0 0;
}

`



const Form = props => {
    const { step, goNext } = props;
    const FIELDS = [
        { caption: "Nome", type: "text", name: "diagnostic_name", isRequired: true },
        { caption: "Número p/ contato", type: "text", name: "diagnostic_number", isRequired: true },
        { caption: "Cargo", type: "text", name: "diagnostic_office", isRequired: true },
        {
            caption: "E-mail", type: "email", name: "diagnostic_email",style: "padding-top: 0ch;", isRequired: true, validate: () => {
                const expression = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
                const regex = new RegExp(expression);
                if(!user.diagnostic_email.match(regex)){
                    return { valid: false };
                }
                if (user.diagnostic_email !== user.diagnostic_email_confirm) {
                    return { valid: false, error: `'E-mail' e 'Confirmar e-mail' são diferentes.` };
                }
                return { valid: true }
            }
        },
        { caption: "Confirmar e-mail", type: "email", name: "diagnostic_email_confirm" },
        { caption: "Nome da empresa", type: "text", name: "diagnostic_company", isRequired: true },
        {
            caption: "Site da empresa", type: "text", name: "diagnostic_url", validate: () => {
                const expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
                const regex = new RegExp(expression);
                return { valid: !user.diagnostic_url || (user.diagnostic_url.match(regex) && true) }
            }
        },

        { caption: "Área/Setor", type: "text", name: "diagnostic_area" },


    ];

    const [user, setUser] = useState(FIELDS.reduce((state, f) => { return { ...state, [f.name]: '' } }, {}));
    const [error, setError] = useState();

    function changeUserInfo(e) {
        setUser({ ...user, [e.target.name]: e.target.value });
    }

    function isFormValidated() {
        const validationObj = FIELDS.reduce((validationObj, field) => {
            const { isRequired, name, caption, validate } = field;
            if (isRequired && (!user[name] || !user[name].trim())) {
                validationObj.valid = false;
                validationObj.errors.push({ field, error: `'${caption}' é obrigatório.` });
            }
            if (validate) {
                const validObj = validate(field);
                if (!validObj.valid) {
                    validationObj.valid = false;
                    validationObj.errors.push({ field, error: validObj.error || `'${caption}' é inválido.` });
                }
            }
            return validationObj;
        }, { valid: true, errors: [] });

        return validationObj;
    }

    function showAllErrors(errors) {
        document.querySelectorAll(".input-field").forEach(input => input.classList.remove('error'));
        errors.forEach(e => {
            document.getElementById(e.field.name).classList.add('error')
        })
        const errs = errors.map((e, i) => <div key={i} className="msgBox"><MessageBox message={e.error} /></div>);
        setError(errs);
    }

    function startQuiz() {
        const validation = isFormValidated();
        if (!validation.valid) {
            showAllErrors(validation.errors)
        } else {
            goNext(user);
        }
    }

    return (
        <Styles>
            {step && <QuizStepDisplay step={step} />}
            <div class="container clearfix">
                <div class="form-widget">
                    <form id="diagnostic-form" class="row mb-0" encType="multipart/form-data">
                        <div class="form-process">
                            <div class="css3-spinner">
                                <div class="css3-spinner-scaler"></div>
                            </div>
                        </div>
                        {FIELDS.map((field, index) => {
                            return (
                                <div key={index} className="col-12 form-group row" id={field.name}>
                                    <label className="col-sm-2 col-form-label" htmlFor={field.name}>{field.caption}: {field.isRequired ? '*' : ''}</label>
                                    <input type={field.type} name={field.name} className= {`form-control col-sm-10 ${field.isRequired ? 'required' : ''}`}
                                        value={user[field.name]} onChange={changeUserInfo} style={{ maxWidth: field.width || '1000px' }}
                                        placeholder={field.placeholder || ''} />
                                </div>
                            )
                        })}
                        <div className="footer">
                            <Button click={startQuiz} caption="Registrar dados" />
                            <div className="errors">{error}</div>
                        </div>
                    </form>
                </div>
            </div>
        </Styles>
    )
}
export default Form;